import ValidService from "../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional - Id tự sinh
  // required - Chứa các mối quan hệ
  quan_he: {
    cha_me_1_id: undefined, // optional, ref: node_gia_pha - Node cha/mẹ của node hiện tại (người trong họ)
    cha_me_2_id: undefined, // optional, ref: node_gia_pha - Node cha/mẹ của node hiện tại (dâu/rể của họ)
    doi_truoc_1_ids: [], // required, array items: required - Danh sách id của các node phía trên (những người trong họ) của node hiện tại
    doi_truoc_3_ids: [], // required, array items: required - Danh sách id của các node phía trên (những người trong họ tính cả dâu/rể) của node hiện tại
    danh_sach_vo_chong: [
      // required - Danh sách các vợ/chồng của node hiện tại
      {
        node_id: undefined, // required, ref: node_gia_pha - Mã node vợ/chồng
        li_di: undefined, // optional - Cho biết có li dị hay không
        da_mat: undefined, // optional - Cho biết có phải đã mất hay không
      },
    ],
    danh_sach_con: [
      // required - Danh sách các con của node hiện tại
      {
        node_id: undefined, // required, ref: node_gia_pha - Mã node con
        con_nuoi: undefined, // optional - Cho biết có phải là con nuôi hay không
      },
    ],
  },
  // required - Chứa thông tin các tên của người dùng
  ten: {
    xung_ho: undefined, // optional, enum(ong, ba, co, chu, anh, chi) - Xưng hô
    ho_ten: undefined, // required - Họ và tên đẩy đủ
    ho_dem: undefined, // required - Họ và đệm
    ten: undefined, // required - Tên
    thuong_goi: undefined, // optional - Tên thường gọi
    biet_hieu: undefined, // optional - Tên biệt hiệu
    huy: undefined, // optional - Tên húy. Là tên  cha mẹ đặt cho từ nhỏ lớn lên ít được nhắc đến (có thể mang nghĩa xấu xí)
    tu: undefined, // optional - Tên tự. Tên của giới trí thức tự đặt thêm cho mình hoặc tên đặt cho một người đàn ông đã qua đời để khấn đọc khi cúng giỗ
    hieu: undefined, // optional - Tên hiệu. Tên của giới trí thức tự đặt thêm cho mình bên cạnh tên vốn có hoặc tên đặt cho một người phụ nữ đã qua đời để khấn đọc khi cúng giỗ
    thuy: undefined, // optional - Tên thụy. Tên đặt cho một người có địa vị xã hội mất đi, dựa vào cuộc đời và sự nghiệp của người đó
  },
  avatar_id: undefined, // optional, ref: mushroom_file - Mã ảnh đại diện
  gioi_tinh: undefined, // required, enum(nam, nu, khac) - Giới tính
  // optional - Thông tin liên quan đến ngày sinh
  sinh: {
    phut: undefined, // optional, min: 0, max: 59 - Phút sinh
    gio: undefined, // optional, min: 0, max: 23 - Giờ sinh
    ngay_sinh: undefined, // optional - Thông tin ngày tháng năm sinh (nếu có đủ) và là ngày dương lịch
    ngay_am: undefined, // optional, min: 1, max: 30 - Ngày âm
    ngay_duong: undefined, // optional, min: 1, max: 31 - Ngày dương
    thang_am: undefined, // optional, min: 1, max: 12 - Tháng âm
    thang_nhuan: undefined, // optional - Cho biết có phải tháng âm nhuận không
    thang_duong: undefined, // optional, min: 1, max: 12 - Tháng dương
    nam_am: undefined, // optional, gt: 0, lt: 2100 - Năm âm
    nam_duong: undefined, // optional, gt: 0, lt: 2100 - Năm duong
    // optional - Nơi sinh
    noi_sinh: {
      quoc_gia_id: undefined, // optional, ref: quoc_gia - Mã quốc gia
      tinh_id: undefined, // optional, ref: province - Mã tỉnh
      huyen_id: undefined, // optional, ref: district - Mã huyện
      xa_id: undefined, // optional, ref: commune - Mã xã
      dia_chi: undefined, // optional - Địa chỉ chi tiết
    },
    // optional - Thông tin can chi
    can_chi: {
      gio: undefined, // optional - Giờ theo can-chi
      ngay: undefined, // optional - Ngày theo can-chi
      thang: undefined, // optional - Tháng theo can-chi
      nam: undefined, // optional - Năm theo can-chi
    },
  },
  // optional - Thông tin liên quan tới ngày mất
  mat: {
    da_mat: undefined, // optional - Cho biết người dùng này đã mất chưa
    phut: undefined, // optional, min: 0, max: 59 - Mất vào phút
    gio: undefined, // optional, min: 0, max: 23 - Mất vào giờ
    ngay_mat: undefined, // optional - Thông tin ngày tháng năm mất (nếu có đủ) và là ngày dương lịch
    ngay_am: undefined, // optional, min: 1, max: 30 - Ngày âm
    ngay_duong: undefined, // optional, min: 1, max: 31 - Ngày dương
    thang_am: undefined, // optional, min: 1, max: 12 - Tháng âm
    thang_nhuan: undefined, // optional - Cho biết có phải tháng âm nhuận không
    thang_duong: undefined, // optional, min: 1, max: 12 - Tháng dương
    nam_am: undefined, // optional, gt: 0, lt: 2100 - Năm âm
    nam_duong: undefined, // optional, gt: 0, lt: 2100 - Năm duong
    // optional - Thông tin can chi
    can_chi: {
      gio: undefined, // optional - Giờ theo can-chi
      ngay: undefined, // optional - Ngày theo can-chi
      thang: undefined, // optional - Tháng theo can-chi
      nam: undefined, // optional - Năm theo can-chi
    },
    mo_id: undefined, // optional, ref: mo - Thông tin mộ
    loai_tang: undefined, // optional, enum(dia_tang, hoa_tang) - Loại táng
  },
  // optional - Thông tin địa chỉ
  dia_chi: {
    quoc_gia_id: undefined, // optional, ref: quoc_gia - Mã quốc gia
    tinh_id: undefined, // optional, ref: province - Mã tỉnh
    huyen_id: undefined, // optional, ref: district - Mã huyện
    xa_id: undefined, // optional, ref: commune - Mã xã
    dia_chi: undefined, // optional - Địa chỉ chi tiết
  },
  // required - Thông tin liên lạc
  thong_tin_lien_lac: {
    dien_thoai: undefined, // required - Số điện thoại
    email: undefined, // optional - Email
    facebook: undefined, // optional - Đường dẫn facebook
    facebook_id: undefined, // optional - Facebook id
    // required - Thông tin zalo của người dùng
    zalo: {
      id: undefined, // optional - ID user trên Zalo
      link: undefined, // optional - Đường dẫn trang cá nhân
      refresh_tokens: [
        // optional - Refresh token của người dùng
        {
          value: undefined, // optional - Giá trị token
          expired_time: undefined, // optional - Thời điểm token hết hạn
        },
      ],
    },
    skype_id: undefined, // optional - Thông tin skype
  },
  // optional - Giấy tờ tùy thân
  giay_to: {
    // optional - Thông tin CMND
    cmnd: {
      so: undefined, // optional, length: 9 - Số CMND
      noi_cap: undefined, // optional - Nơi cấp
      ngay_cap: undefined, // optional - Ngày cấp
      anh_mat_truoc_id: undefined, // optional, ref: mushroom_file - Ảnh mặt trước CMND
      anh_mat_sau_id: undefined, // optional, ref: mushroom_file - Ảnh mặt sau CMND
    },
    // optional - Thông tin CCCD
    cccd: {
      so: undefined, // optional - Số CCCD
      noi_cap: undefined, // optional - Nơi cấp
      ngay_cap: undefined, // optional - Ngày cấp
      ngay_het_han: undefined, // optional - Ngày hết hạn
      qr: undefined, // optional - QR code của CCCC gắn chip
      anh_mat_truoc_id: undefined, // optional, ref: mushroom_file - Ảnh mặt trước CCCC
      anh_mat_sau_id: undefined, // optional, ref: mushroom_file - Ảnh mặt sau CCCC
    },
    // optional - Thông tin Hộ chiếu
    passport: {
      so: undefined, // optional - Số CCCD
      noi_cap: undefined, // optional - Nơi cấp
      ngay_cap: undefined, // optional - Ngày cấp
      anh_id: undefined, // optional, ref: mushroom_file - Ảnh chụp passport trang có mặt
    },
  },
  // optional - Các thông tin liên quan đến học vấn
  hoc_van: {
    hoc_ham: undefined, // optional, enum(giao_su, pho_giao_su) - Học hàm
    hoc_vi: undefined, // optional, enum(tien_sy_khoa_hoc, tien_sy, thac_sy, bac_sy, ky_su, cu_nhan, tu_tai) - Học vị
    qua_trinh: [
      // optional - Thông tin quá trình học tập
      {
        tu: undefined, // optional - Từ ngày
        tu_nam: undefined, // optional - Từ năm
        den: undefined, // optional - Đến ngày
        den_nam: undefined, // optional - Đến năm
        cap_hoc: undefined, // optional, enum(mam_non, mau_giao, tieu_hoc, trung_hoc, pho_thong, trung_tam_dao_tao, trung_cap, cao_dang, dai_hoc, sau_dai_hoc) - Cấp học
        ten_truong: undefined, // optional - Tên trường
        da_tot_nghiep: undefined, // optional - Cho biết đã tốt nghiệp chưa
      },
    ],
  },
  // optional - Các thông tin liên quan đến nghề nghiệp
  cong_viec: {
    nghe_nghiep: undefined, // optional - Nghề nghiệp hiện tại
    noi_cong_tac: undefined, // optional - Nơi công tác
    chuc_vu: undefined, // optional - Chức vụ
  },
  // optional - Thông tin sinh tồn
  sinh_ton: {
    gioi_tinh: undefined, // optional, enum(nam, nu) - Giới tính (danh cho trường hợp giới tính là khác)
    chieu_cao: undefined, // optional, gt: 0, lt: 3 - Chiều cao (m)
    nhom_mau: undefined, // optional, enum(A, B, O, AB) - Nhóm máu
    benh_di_truyen: [], // optional, array items: required - Danh sách bệnh di truyền
  },
  ton_giao_id: undefined, // optional, ref: ton_giao - Mã tôn giáo
  user_id: undefined, // optional, ref: mushroom_user - Mã user gắn với người dùng
  kich_hoat: undefined, // required - Người dùng đã kích hoạt hay chưa
};

// validation form
model.validForm = {
  "ten.ho_ten": [ValidService.required],
  "thong_tin_lien_lac.email": [ValidService.required],
  "ten.xung_ho": [ValidService.required],
  ten_dong_ho: [ValidService.required],
  ten_huyen: [ValidService.required],
  ten_xa: [ValidService.required],
  dia_chi: [ValidService.required],
};

model.options = [
  {
    value: "true",
    label: "Tài khoản bị khóa",
  },
  {
    value: "false",
    label: "Tài khoản hoạt động",
  },
];
model.optionsRoles = [
  {
    value: "FamilyAdmin",
    label: "FamilyAdmin",
  },
  {
    value: "FamilyUser",
    label: "FamilyUser",
  },
  {
    value: "FamilyModerator",
    label: "FamilyModerator",
  },
];
model.optionsRolesAll = [
  {
    value: "FamilyAdmin",
    label: "FamilyAdmin",
  },
  {
    value: "FamilyUser",
    label: "FamilyUser",
  },
  {
    value: "User",
    label: "User",
  },
  {
    value: "SystemAdmin",
    label: "SystemAdmin",
  },
  {
    value: "ContentAdmin",
    label: "ContentAdmin",
  },
];

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "",
  defaultSort: ["account", "ascending"],
  filtersFamily: ["disabled=false", "roles:in:FamilyAdmin,FamilyUser,FamilyModerator"],
  filtersSale: ["roles:in:SalesUser"],
  filtersContent: ["roles:in:ContentAdmin"],

  recordSelected: [],

  dataSearch: {
    value: {
      account: "",
      disabled: "",
      roles: "",
    },
    valid: {},
    operator: {
      account: ":regex_i:",
      disabled: "",
      roles: ":in:",
    },
  },
};

export default model;
